import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "@/contexts/AuthContext";
import { UserPreferencesProvider } from "@/contexts/UserPreferencesContext";
import { SubscriptionProvider } from "@/contexts/SubscriptionContext";
import { ToastProvider } from "@/components/ui/toast";
import App from "./App";
import "./index.css";

// Expose migration/utility functions for one-time use
import { migrateWordsGrammar, clearAllGrammarData, cleanupStudySets } from "@/hooks/useFirestore";
(window as any).migrateWordsGrammar = migrateWordsGrammar;
(window as any).clearAllGrammarData = clearAllGrammarData;
(window as any).cleanupStudySets = cleanupStudySets;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 30, // 30 seconds - refetch when navigating if data is older
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <UserPreferencesProvider>
            <SubscriptionProvider>
              <ToastProvider>
                <App />
              </ToastProvider>
            </SubscriptionProvider>
          </UserPreferencesProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
